var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings-alt",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,5.5 C2.3954305,5.5 1.5,4.6045695 1.5,3.5 C1.5,2.3954305 2.3954305,1.5 3.5,1.5 C4.6045695,1.5 5.5,2.3954305 5.5,3.5 C5.5,4.03043298 5.28928632,4.53914081 4.91421356,4.91421356 C4.53914081,5.28928632 4.03043298,5.5 3.5,5.5 Z M3.5,2.5 C2.94771525,2.5 2.5,2.94771525 2.5,3.5 C2.5,4.05228475 2.94771525,4.5 3.5,4.5 C4.05228475,4.5 4.5,4.05228475 4.5,3.5 C4.5,3.23478351 4.39464316,2.9804296 4.20710678,2.79289322 C4.0195704,2.60535684 3.76521649,2.5 3.5,2.5 Z M3.5,14.5 C2.3954305,14.5 1.5,13.6045695 1.5,12.5 C1.5,11.3954305 2.3954305,10.5 3.5,10.5 C4.6045695,10.5 5.5,11.3954305 5.5,12.5 C5.5,13.6045695 4.6045695,14.5 3.5,14.5 Z M3.5,11.5 C2.94771525,11.5 2.5,11.9477153 2.5,12.5 C2.5,13.0522847 2.94771525,13.5 3.5,13.5 C4.05228475,13.5 4.5,13.0522847 4.5,12.5 C4.5,11.9477153 4.05228475,11.5 3.5,11.5 Z M7.5,3 L14,3 L14,4 L7.5,4 L7.5,3 Z M7.5,12.015 L14,12.015 L14,13.015 L7.5,13.015 L7.5,12.015 Z M12,10 C10.8954305,10 10,9.1045695 10,8 C10,6.8954305 10.8954305,6 12,6 C13.1045695,6 14,6.8954305 14,8 C14,8.53043298 13.7892863,9.03914081 13.4142136,9.41421356 C13.0391408,9.78928632 12.530433,10 12,10 Z M12,7 C11.4477153,7 11,7.44771525 11,8 C11,8.55228475 11.4477153,9 12,9 C12.5522847,9 13,8.55228475 13,8 C13,7.44771525 12.5522847,7 12,7 Z M2,7.49 L8.5,7.49 L8.5,8.49 L2,8.49 L2,7.49 Z",
    id: "settings"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsAlt);
export default __webpack_public_path__ + "static/media/settings-alt.68cc111b79baf14c971d5a3fb94d2c8c.svg";
export { ForwardRef as ReactComponent };